import { Grid, Typography } from '@kc-console/common-ui';
import { t } from '@kc-console/core';

import Hotkey from '../components/AppMenu/Gnb/SettingMenu/Hotkey';

export function getMacHotKeyModalData() {
  return {
    title: t('layout:setting.hotkey.mac.title'),
    sections: [
      {
        subSections: [
          {
            title: t('layout:setting.hotkey.shortcuts'),
            items: [
              {
                label: t('layout:setting.hotkey.search'),
                value: (
                  <Grid container gap={'4px'}>
                    <Hotkey text={'⌘'} />
                    <Hotkey text={'K'} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.all_services'),
                value: (
                  <Grid container alignItems={'center'} gap={'4px'}>
                    <Hotkey text={'G'} />
                    <Typography variant={'body/normal/md'}>then</Typography>
                    <Hotkey text={'A'} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.favorites'),
                value: (
                  <Grid container alignItems={'center'} gap={'4px'}>
                    <Hotkey text={'G'} />
                    <Typography variant={'body/normal/md'}>then</Typography>
                    <Hotkey text={'F'} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.dashboard'),
                value: (
                  <Grid container alignItems={'center'} gap={'4px'}>
                    <Hotkey text={'G'} />
                    <Typography variant={'body/normal/md'}>then</Typography>
                    <Hotkey text={'D'} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.user_guide'),
                value: (
                  <Grid container alignItems={'center'} gap={'4px'}>
                    <Hotkey text={'G'} />
                    <Typography variant={'body/normal/md'}>then</Typography>
                    <Hotkey text={'U'} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.helpdesk'),
                value: (
                  <Grid container alignItems={'center'} gap={'4px'}>
                    <Hotkey text={'G'} />
                    <Typography variant={'body/normal/md'}>then</Typography>
                    <Hotkey text={'H'} />
                  </Grid>
                ),
              },
            ],
            useBottomBorder: true,
          },
          {
            title: t('layout:setting.hotkey.open_close'),
            items: [
              {
                label: t('layout:setting.hotkey.toggle_left_panel'),
                value: (
                  <Grid container gap={'4px'}>
                    <Hotkey text={'⌥'} />
                    <Hotkey text={'['} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.toggle_right_panel'),
                value: (
                  <Grid container gap={'4px'}>
                    <Hotkey text={'⌥'} />
                    <Hotkey text={']'} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.close_modal'),
                value: <Hotkey text={'Esc'} />,
              },
            ],
          },
        ],
      },
      {
        subSections: [
          {
            title: t('layout:setting.hotkey.new_item'),
            items: [
              {
                label: t('layout:setting.hotkey.create_resource'),
                value: (
                  <Grid container gap={'4px'}>
                    <Hotkey text={'⌘'} />
                    <Hotkey text={'⌥'} />
                    <Hotkey text={'N'} />
                  </Grid>
                ),
              },
            ],
            useBottomBorder: true,
          },
          {
            title: t('layout:setting.hotkey.change'),
            items: [
              {
                label: t('layout:setting.hotkey.change_region'),
                value: (
                  <Grid container gap={'4px'}>
                    <Hotkey text={'⌘'} />
                    <Hotkey text={'⌥'} />
                    <Hotkey text={'R'} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.change_project'),
                value: (
                  <Grid container gap={'4px'}>
                    <Hotkey text={'⌘'} />
                    <Hotkey text={'⌥'} />
                    <Hotkey text={'P'} />
                  </Grid>
                ),
              },
            ],
            useBottomBorder: true,
          },
          {
            title: t('layout:setting.hotkey.info'),
            items: [
              {
                label: t('layout:setting.hotkey.open_popup'),
                value: (
                  <Grid container gap={'4px'}>
                    <Hotkey text={'⌘'} />
                    <Hotkey text={'/'} />
                  </Grid>
                ),
              },
            ],
          },
        ],
      },
    ],
  };
}

export function getWindowsHotKeyModalData() {
  return {
    title: t('layout:setting.hotkey.window.title'),
    sections: [
      {
        subSections: [
          {
            title: t('layout:setting.hotkey.shortcuts'),
            items: [
              {
                label: t('layout:setting.hotkey.search'),
                value: (
                  <Grid container gap={'4px'}>
                    <Hotkey text={'Ctrl'} />
                    <Hotkey text={'K'} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.all_services'),
                value: (
                  <Grid container alignItems={'center'} gap={'4px'}>
                    <Hotkey text={'G'} />
                    <Typography variant={'body/normal/md'}>then</Typography>
                    <Hotkey text={'A'} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.favorites'),
                value: (
                  <Grid container alignItems={'center'} gap={'4px'}>
                    <Hotkey text={'G'} />
                    <Typography variant={'body/normal/md'}>then</Typography>
                    <Hotkey text={'F'} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.dashboard'),
                value: (
                  <Grid container alignItems={'center'} gap={'4px'}>
                    <Hotkey text={'G'} />
                    <Typography variant={'body/normal/md'}>then</Typography>
                    <Hotkey text={'D'} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.user_guide'),
                value: (
                  <Grid container alignItems={'center'} gap={'4px'}>
                    <Hotkey text={'G'} />
                    <Typography variant={'body/normal/md'}>then</Typography>
                    <Hotkey text={'U'} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.helpdesk'),
                value: (
                  <Grid container alignItems={'center'} gap={'4px'}>
                    <Hotkey text={'G'} />
                    <Typography variant={'body/normal/md'}>then</Typography>
                    <Hotkey text={'H'} />
                  </Grid>
                ),
              },
            ],
            useBottomBorder: true,
          },
          {
            title: t('layout:setting.hotkey.open_close'),
            items: [
              {
                label: t('layout:setting.hotkey.toggle_left_panel'),
                value: (
                  <Grid container gap={'4px'}>
                    <Hotkey text={'Alt'} />
                    <Hotkey text={'['} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.toggle_right_panel'),
                value: (
                  <Grid container gap={'4px'}>
                    <Hotkey text={'Alt'} />
                    <Hotkey text={']'} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.close_modal'),
                value: <Hotkey text={'Esc'} />,
              },
            ],
          },
        ],
      },
      {
        subSections: [
          {
            title: t('layout:setting.hotkey.new_item'),
            items: [
              {
                label: t('layout:setting.hotkey.create_resource'),
                value: (
                  <Grid container gap={'4px'}>
                    <Hotkey text={'Alt'} />
                    <Hotkey text={'Win'} />
                    <Hotkey text={'N'} />
                  </Grid>
                ),
              },
            ],
            useBottomBorder: true,
          },
          {
            title: t('layout:setting.hotkey.change'),
            items: [
              {
                label: t('layout:setting.hotkey.change_region'),
                value: (
                  <Grid container gap={'4px'}>
                    <Hotkey text={'Alt'} />
                    <Hotkey text={'Win'} />
                    <Hotkey text={'R'} />
                  </Grid>
                ),
              },
              {
                label: t('layout:setting.hotkey.change_project'),
                value: (
                  <Grid container gap={'4px'}>
                    <Hotkey text={'Alt'} />
                    <Hotkey text={'Win'} />
                    <Hotkey text={'P'} />
                  </Grid>
                ),
              },
            ],
            useBottomBorder: true,
          },
          {
            title: t('layout:setting.hotkey.info'),
            items: [
              {
                label: t('layout:setting.hotkey.open_popup'),
                value: (
                  <Grid container gap={'4px'}>
                    <Hotkey text={'Ctrl'} />
                    <Hotkey text={'/'} />
                  </Grid>
                ),
              },
            ],
          },
        ],
      },
    ],
  };
}
